import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TertiaryTextWrapper } from "./TertiaryText.styles";
var TertiaryText = function(param) {
    var children = param.children, className = param.className, textColor = param.textColor;
    return /*#__PURE__*/ _jsx(TertiaryTextWrapper, {
        className: className,
        textColor: textColor,
        children: children
    });
};
export { TertiaryText };
